module.exports = __webpack_public_path__ + "static/Mrs Yaa Owusua-06d1679c686fcdf5da240ceb5125b631.png";